<template>
    <canvas v-show="parseInt(0)" class="canvasAreaPreview" v-bind:id="'canvas_'+this.uuid" v-bind:width="label.width +'px'" v-bind:height="label.height+'px'"></canvas>
</template>
<script>
    export default {
        props: ['label','uuid'],
        components: {
        },
        methods: {
            draw: function (event) {
                if(this.label.preview_type != "svgPreview"){
                    return false;
                }
                var page = $jQuery(".pageUnique_"+this.uuid);

                if(page.length){
                    var scale = page.data('scale');
                    if(typeof(scale) == "undefined") {
                        scale = 1;
                    }
                    var displayedTexts = page.find(".previewLineContainer.isDisplayed");
                    var displayedCliparts = page.find(".previewClipartContainer");
                    var displayedBackgrounds = page.find(".previewBackgroundContainer");
                    this.loadImage(displayedCliparts);
                    this.loadImage(displayedBackgrounds);
                    var instance = this;
                    var myVar=setInterval(function (){
                          if( labelVariables.urlToLoad.length == 0) {
                              var c = document.getElementById("canvas_" + instance.uuid);
                              var ctx = c.getContext("2d");

                              var multiplier = 2;
                              ctx.save();

                              ctx.transform.apply(ctx, [multiplier, 0, 0, multiplier, 0, 0]);
                              c.width = (c.width * multiplier)+15;
                              c.height = c.height * multiplier;
                              ctx.clearRect(0, 0, c.width, c.height);
                              instance.drawCliparts(ctx, displayedBackgrounds, scale,multiplier);
                              instance.drawLines(ctx, displayedTexts, scale, page,multiplier);
                              instance.drawCliparts(ctx, displayedCliparts, scale ,multiplier);
                              clearInterval(myVar);
                              var img_tag = page.parent().parent().find("svg #ggmImage");
                              img_tag.attr('xlink:href', c.toDataURL());
                              ctx.restore();
                              c.width =( c.width-15 )/ multiplier;
                              c.height = c.height / multiplier;
                        }
                    }, 100);



                }
            },
            loadImage : function(blocks,url){
                $jQuery.each(blocks, function(index,item){
                    var block = $jQuery(item);
                    var url = block.css('background-image');
                    var url = url.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                    if (url.length && url != "none") {
                        if (labelVariables.urlToLoad.indexOf(url) < 0 && labelVariables.links.indexOf(url) < 0) {
                            labelVariables.urlToLoad.push(url);
                            var img = new Image();
                            img.setAttribute('crossorigin', 'anonymous')
                            img.src = url;
                            img.onload = (function (url, img) {
                                return function () {
                                    labelVariables.links.push(url);
                                    labelVariables.imgs.push(img);
                                    var offset = labelVariables.urlToLoad.indexOf(url);
                                    labelVariables.urlToLoad = labelVariables.urlToLoad.filter(function (value, index) {
                                        return offset != index;
                                    });
                                }
                            })(url, img)
                        }
                    }
                });

            },
            drawLines    : function(ctx, displayedTexts, scale,page,multiplier){
                if (this.label.lines.length) {
                    var pw = parseFloat(this.label.lines[0].page_resize_percentageH) / 100;
                    var rw = parseFloat(this.label.lines[0].page_resize_percentageW) / 100;
                    var rh = parseFloat(this.label.lines[0].page_resize_percentageH) / 100;
                    if (displayedTexts.length) {
                        $jQuery.each(displayedTexts, function (i, v) {
                            var displayetText = $jQuery(v);
                            var spans = displayetText.find('span');
                            var type = 0;
                            if (!spans.length) {
                                spans = displayetText.find('.editArea');
                                var type = 1;
                            }

                            $jQuery.each(spans, function (index, item) {
                                var span = $jQuery(item);
                                var masterBounding = span.parent().get(0).getBoundingClientRect();
                                var spanBounding = span.get(0).getBoundingClientRect();
                                var pageBlockContainerBounding = span.parents('.page_blocks_container').get(0).getBoundingClientRect();
                                var fontSize = parseFloat(span.css('font-size'));
                                var color = (span.css('color'));
                                var fontFamily = span.css('font-family');
                                fontSize*=rh;
                                span.addClass('removeDisplay2');
                                var text = span.text();
                                var cbGetter = $jQuery("#cbGetter");
                                cbGetter.html((span.text()));
                                cbGetter.css({
                                    'font-family': '"' + fontFamily + '"',
                                    'font-size':( (fontSize*0.75)) + "pt"
                                });

                                ctx.font = (fontSize*multiplier) + "px " + fontFamily;

                                ctx.textBaseline = "bottom";
                                var cbGetterBounding = cbGetter.get(0).getBoundingClientRect();

                               var diff = 0;
                                if (span.hasClass('editArea') && span.css('vertical-align') == "middle") {
                                    diff = (spanBounding.height / scale - cbGetterBounding.height) / 2;
                                }
                                if (span.get(0).tagName.toLowerCase() == 'span') {
                                    diff = (spanBounding.height / scale - cbGetterBounding.height) / 2;
                                }


                                var bottomText = (spanBounding.top - pageBlockContainerBounding.top) / scale +diff;
                                var params = {
                                    font: fontFamily,
                                    font_size: fontSize*0.75
                                };

                                var fontF = getFontForge(params);
                                var top = bottomText + ( fontF.top);
                                var diffLeft = 0;
                                if(span.css('text-align') == "center"){
                                    diffLeft= (masterBounding.width / scale - cbGetterBounding.width) / 2
                                }
                                var left = (spanBounding.left - pageBlockContainerBounding.left) + diffLeft;
                                ctx.fillStyle = color;
                                ctx.fillText(text, left*multiplier, top *multiplier);
                                span.removeClass('removeDisplay2');
                            });
                        })


                    }
                }
            },
            drawCliparts : function(ctx, displayedCliparts, scale, multiplier){
                if(displayedCliparts.length){
                    $jQuery.each(displayedCliparts, (function(ctx,scale,instance){
                        return function (index, clipart) {
                            var itemClipart = $jQuery(clipart);
                            var url = itemClipart.css('background-image');
                            var url = url.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                            if (url.length && url != "none") {
                                var img = null;
                                var position = itemClipart.position();
                                var pw = parseFloat(instance.label.cliparts_blocks[0].page_resize_percentageH) / 100;
                                var bounding = {
                                    width: itemClipart.width(),
                                    height: itemClipart.height()
                                };
                                if(labelVariables.links.indexOf(url) > -1){
                                    img = labelVariables.imgs[labelVariables.links.indexOf(url)];
                                    instance.drawImage(ctx,img, position, bounding, url,scale,multiplier);
                                }else{
                                    var img = new Image();
                                    img.setAttribute('crossorigin', 'anonymous')
                                    img.src = url;
                                }
                            }
                        }
                    })(ctx, scale, this));
                }
            },
            drawImage : function(ctx,img,position, bounding, url,scalePage,multiplier){
                var offsetX = 0.5;
                var offsetY = 0.5;
                var scale = 1;
                var childWidth = img.width;
                var parentWidth = bounding.width;
                var childHeight = img.height;
                var parentHeight = bounding.height;
                var childRatio = childWidth / childHeight
                var parentRatio = parentWidth / parentHeight
                var width = parentWidth * scale
                var height = parentHeight * scale

                if (childRatio > parentRatio) {
                    height = width / childRatio
                } else {
                    width = height * childRatio
                }
                offsetX = (parentWidth - width) * offsetX,
                    offsetY = (parentHeight - height) * offsetY
                ctx.drawImage(img, (offsetX + position.left/ scalePage)*multiplier, (offsetY + position.top/ scalePage) * multiplier, width*multiplier, height*multiplier);
                labelVariables.links.push(url);
                labelVariables.imgs.push(img);
            }
        },

        mounted : function(){
            window.addEventListener('updateCanvas', this.draw)
        }
    }
</script>
<style>
    .canvasAreaPreview {
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        position: absolute;
        z-index:999;
    }
    .labelsContainer .svgPreview .pages{
        position: absolute !important;
        top: -15000px !important;
        left: -15000px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Canvas/Canvas.vue